.InstitutionCard {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-weight: 600;
  max-width: 20rem;
  width: 100%;

  & img {
    width: 3rem;
    height: 3rem;
    margin-right: 1rem;
    border-radius: 10rem;
  }
}
